import { GridColumnVisibilityModel, GridFilterModel, GridSortModel } from '@mui/x-data-grid-premium'

export const defaultColumnOrder: string[] = [
  'deal_uuid',
  'predecessorId',
  'successorId',
  'name',
  'dealStatus',
  'oldStatus',
  'monthlyTotal',
  'total',
  'grossMargin',
  'type',
  'seoTier',
  'startDate',
  'endDate',
  'contractId',
  'noSignature',
  'organization',
  'daysLeft',
  'contractedBy',
  'status',
  'stage',
  'lastDateOfService',
  'lastModified',
  'timeCompleted',
  'owner',
  'implementationFee',
  'creation_timestamp',
  'probability',
  'weightedTotal',
  'isGoogleDisplay',
  'isGoogleSearch',
  'isLinkedIn',
  'isMetaAdvertising',
  'isMicrosoftAdvertising',
  'isSimplifi',
  'isSnapchat',
  'isSpotify',
  'isTikTok',
  'isYoutube',
  'isSeo1',
  'isSeo2',
  'isSeo3',
  'isSeo4',
]
export const initialVisibilityState: GridColumnVisibilityModel = {
  lastDateOfService: false,
  implementationFee: false,
  lastModified: false,
  type: false,
  endDate: false,
  creation_timestamp: false,
  isGoogleDisplay: false,
  isGoogleSearch: false,
  isLinkedIn: false,
  isMetaAdvertising: false,
  isMicrosoftAdvertising: false,
  isSimplifi: false,
  isSnapchat: false,
  isSpotify: false,
  isTikTok: false,
  isYoutube: false,
  isSeo1: false,
  isSeo2: false,
  isSeo3: false,
  isSeo4: false,
  seoTier: false,
  probability: false,
  weightedTotal: false,
  deal_uuid: false,
  oldStatus: false,
  predecessorId: false,
  successorId: false,
  startDate: false,
  source: false,
  orgNameReference: false,
  noSignature: false,
  docName: false,
  docStatus: false,
  docTimeCreation: false,
  __tree_data_group__: false,
}
export const defaultSortModel: GridSortModel = [
  // { field: 'lastModified', sort: 'desc' },
  { field: 'creation_timestamp', sort: 'desc' },
  { field: 'name', sort: 'asc' },
  { field: 'organizations', sort: 'asc' },
  { field: 'status', sort: 'asc' },
]
export const pinnedColumns = { left: ['__check__'], right: [] }

export const defaultVisibilityModel: GridColumnVisibilityModel = {
  ...initialVisibilityState,
  __tree_data_group__: false, // Hide tree-specific columns
}

export const defaultFilterModel: GridFilterModel = {
  items: [],
  quickFilterValues: [],
  quickFilterExcludeHiddenColumns: false,
}
